// extracted by mini-css-extract-plugin
module.exports = {"baggage_wrapper":"baggage_wrapper-_ORGD","description":"description-2rwRM","price_label":"price_label-Z9agl","label":"label-1QVGK"};